<template>
<div>
    <template v-if="is_showBtn">
        <v-btn
          @click.stop="showDialog(reserve_id)"
          class="mygreen"
          dark
        >
            <img class="img" src="/img/icon_syochi.svg" style="margin-left: -6px;margin-right:6px;height:26px;" />
          <span>処置内容</span></v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">処置内容</span></v-toolbar>
        <v-card-text class="pb-0">
          <v-container>
            <v-row>
              <v-col class="text-left" cols="3">P処置</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_p_syochi" :key="v.id">
                      <v-checkbox
                          v-model="data.p_syochi"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">C処置</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_c_syochi" :key="v.id">
                      <v-checkbox
                          v-model="data.c_syochi"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">補綴(義歯)</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_hotei" :key="v.id">
                      <v-checkbox
                          v-model="data.hotei"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">抜歯</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_basshi" :key="v.id">
                      <v-checkbox
                          v-model="data.basshi"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>
              <v-col class="text-left" cols="3">予防</v-col>
              <v-col cols="9" class="pt-0">
                  <div v-for="v in def_yobou" :key="v.id">
                      <v-checkbox
                          v-model="data.yobou"
                          :value="v.name"
                          :label="v.name"
                          color="rgba(0, 189, 242, 1)"
                      />
                  </div>
              </v-col>





            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-8">
          <v-spacer></v-spacer>
          <v-btn
            color="white"
            @click="dialog = false">戻る</v-btn>
          <v-btn dark
            class="mygreen"
            @click="save()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */


export default {
    props: {
      is_showBtn: Boolean,
      reserve_id: String,
    },

    created(){
        console.log('%ccreated: DialogSyochinaiyou.vue', mycolor.purple);
        console.log(this.data);
    },
    // datas
    data() {
            return {
                dialog: false,

                def_p_syochi: [
                    {id: 1, name: "TBI"},
                    {id: 2, name: "SC"},
                    {id: 3, name: "SRP"},
                    {id: 4, name: "Pe"},
                    {id: 5, name: "P-cur"},
                    {id: 6, name: "F-ope"},
                    {id: 7, name: "P検査（P基検、P精検）"}
                ],
                def_c_syochi: [
                    {id: 1, name: "CR充填"},
                    {id: 2, name: "KP"},
                    {id: 3, name: "PZ"},
                    {id: 4, name: "imp"},
                    {id: 5, name: "プロビ"},
                    {id: 6, name: "麻髄"},
                    {id: 7, name: "感処"},
                    {id: 8, name: "RCT"},
                    {id: 9, name: "RCF"},
                    {id: 10, name: "コアSET"},
                ],
                def_hotei: [
                    {id: 1, name: "概形imp"},
                    {id: 2, name: "精密imp"},
                    {id: 3, name: "BT床"},
                    {id: 4, name: "GoA"},
                    {id: 5, name: "WAX TF"},
                    {id: 6, name: "クラスプTF"},
                    {id: 7, name: "SET"},
                    {id: 8, name: "adj"},
                ],
                def_basshi: [
                    {id: 1, name: "Ext"},
                    {id: 2, name: "Sp"},
                    {id: 3, name: "SR"},
                ],
                def_yobou: [
                    {id: 1, name: "F(フッ素)"},
                    {id: 2, name: "Si(シーラント)"},
                    {id: 3, name: "white(ホワイトニング)"},
                ],
                data: {
                    reserve_id: '',

                    p_syochi: [],
                    c_syochi: [],
                    hotei: [],
                    basshi: [],
                    yobou: [],
                }
            }
    },  // datas
    methods: {
        save(){
            console.log('save');
            console.log(this.data);
            this.$emit('submit_syochi', this.data);
            this.dialog = false;
        },
        showDialog(reserve_id){
            console.log('showDialog()');
            this.dialog = true;
            console.log('reserve_id', reserve_id);
            this.data.reserve_id = reserve_id;

            axios.get( '/reserve/' + reserve_id )
              .then((res) => {
                console.group();
                console.log('%c %s', mycolor.api, '/reserve');
                console.log('処置内容データ取得完了');
                console.log(res.data);
                console.groupEnd();


                // todo: もしデータ取れなかったら?
                if(res.data){
                    for (const [key, value] of Object.entries(res.data)) {
                      if( key in this.data ){
                          console.log(key)
                          this.data[key] = value;
                      }
                    }
                }

                console.log('this.data', this.data);


              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });
        },
    }, // methods

}
</script>

<style scoped>
.v-input.theme--light.v-input--selection-controls.v-input--checkbox {
    margin: 0;
    height: 40px;
}
.v-input--selection-controls.v-input{
    margin: 0;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .v-list-item__content{
    text-align: left;
}
</style>
